/// <amd-module name="Wit/Settings/BoardsExternalIntegration/utils/TextUtil" />
import * as React from "react";
import { Link } from "VSSUI/Link";
import { OAuthErrorCode } from "Wit/Clients/Internal/Contracts/ConnectedService";
import { GitHubConnectionConstants } from "Wit/Settings/BoardsExternalIntegration/constants/Constants";
import * as Resources from "Wit/Settings/BoardsExternalIntegration/Resources";

export function getFetchGitHubConnectionsErrorText(): JSX.Element {
    return (
        <span>
            {Resources.FetchGitHubConnections_Error}{" "}
            <Link className="support-page-link" target="_blank" href={GitHubConnectionConstants.AzureDevOpsSupportPageUrl}>
                {Resources.SupportPageLink_Text}
            </Link>
        </span>
    );
}

export function getErrorMessageFromCode(errorCode: string, isGHE: string): string {
    const isGitHubEnterprise = isGHE === "true";
    const errorCodeInt = Number(errorCode);
    switch (errorCodeInt) {
        case OAuthErrorCode.RetryableError:
            return Resources.OAuthRetryableErrorMessage;
        case OAuthErrorCode.NetworkError:
            return isGitHubEnterprise ? Resources.NetworkErrorGHEMessage : Resources.NetworkErrorGHMessage;
        case OAuthErrorCode.HttpNotFoundError:
            return isGitHubEnterprise ? Resources.HttpNotFoundGHEMessage : Resources.UnspecifiedGitHubError;
        case OAuthErrorCode.ClientSecretIsInvalid:
            return isGitHubEnterprise ? Resources.ClientSecretIsInvalidMessage : Resources.UnspecifiedGitHubError;
        case OAuthErrorCode.OAuthConfigurationError:
            return isGitHubEnterprise ? Resources.OAuthConfigurationErrorMessage : Resources.UnspecifiedGitHubError;
        case OAuthErrorCode.UnspecifiedError:
        default:
            return isGitHubEnterprise ? Resources.UnspecifiedGitHubEnterpriseError : Resources.UnspecifiedGitHubError;
    }
}
